// extracted by mini-css-extract-plugin
export var icon = "_4b-1";
export var subtext = "_4b-0";